import React, {useState, useEffect, Fragment} from "react";
import {LeaderboardUsersType, LeaderboardsTabsType} from "modules";
import {useSelector, useDispatch} from "react-redux";
import {getCurrentLeague} from "modules/selectors";
import LeaderboardContent from "components/Leaderboard/LeaderboardContent";
import {clearLeaderboard} from "modules/actions/leaderboards";
import {LeaderboardSwitcher} from "components/Leaderboard/LeaderboardSwitcher";
import styled from "@emotion/styled";
import {Outlet} from "react-router-dom";

const Wrapper = styled.div`
	padding: 16px 0;
	display: flex;
	flex-flow: column;
	overflow: hidden;
	height: 100%;
`;

const SwitchWrapper = styled.div`
	max-width: 300px;
	margin-left: auto;

	@media (max-width: 880px) {
		max-width: 100%;
		margin: 0;
	}
`;

const Border = styled.div`
	position: relative;
	padding: 16px 0 0;
	overflow: hidden;
`;

const GroupTable: React.FC = () => {
	const dispatch = useDispatch();
	const currentLeague = useSelector(getCurrentLeague);
	const [currentPage, setCurrentPage] = useState(1);
	const [leaderboardType, setLeaderboardType] = useState(LeaderboardsTabsType.ActiveStreak);

	useEffect(() => {
		return () => {
			dispatch(clearLeaderboard());
		};
	}, [dispatch]);

	return (
		<Fragment>
			<Wrapper>
				<SwitchWrapper>
					<LeaderboardSwitcher
						value={leaderboardType}
						ariaLabel={"Active Streak or Season Best"}
						onChange={(type: string) => {
							setLeaderboardType(type as LeaderboardsTabsType);
						}}
						options={[
							{
								label: "Active Streak",
								value: LeaderboardsTabsType.ActiveStreak,
							},
							{
								label: "Season Best",
								value: LeaderboardsTabsType.AllSeason,
							},
						]}
					/>
				</SwitchWrapper>

				<Border aria-live={"polite"}>
					<LeaderboardContent
						leaderboardUsersType={LeaderboardUsersType.All}
						setCurrentPage={setCurrentPage}
						currentPage={currentPage}
						leagueId={currentLeague?.id}
						selectedTab={leaderboardType}
					/>
				</Border>
			</Wrapper>
			<Outlet />
		</Fragment>
	);
};

export default GroupTable;
